var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOracles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C13.1046 14.5 14 13.6046 14 12.5C14 11.3954 13.1046 10.5 12 10.5C10.8954 10.5 10 11.3954 10 12.5C10 13.6046 10.8954 14.5 12 14.5Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2401 8.26C16.7979 8.81724 17.2405 9.47897 17.5424 10.2074C17.8444 10.9357 17.9998 11.7165 17.9998 12.505C17.9998 13.2935 17.8444 14.0743 17.5424 14.8026C17.2405 15.531 16.7979 16.1928 16.2401 16.75M7.76006 16.74C7.2022 16.1828 6.75965 15.521 6.4577 14.7926C6.15576 14.0643 6.00034 13.2835 6.00034 12.495C6.00034 11.7065 6.15576 10.9257 6.4577 10.1974C6.75965 9.46897 7.2022 8.80724 7.76006 8.25M19.0701 5.43C20.9448 7.30528 21.9979 9.84836 21.9979 12.5C21.9979 15.1516 20.9448 17.6947 19.0701 19.57M4.93006 19.57C3.05535 17.6947 2.0022 15.1516 2.0022 12.5C2.0022 9.84836 3.05535 7.30528 4.93006 5.43",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracles);
export default __webpack_public_path__ + "static/media/oracles.75750da1a2b72f565ea924213f551e4b.svg";
export { ForwardRef as ReactComponent };